import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src296139272/src/src/layouts/default.vue").then(m => m.default || m)),
  "with-global-nav": defineAsyncComponent(() => import("/codebuild/output/src296139272/src/src/layouts/withGlobalNav.vue").then(m => m.default || m))
}